module.exports = __webpack_public_path__ + "img/ISTJ.65215412.png";